import axios from 'axios';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.timeout = 180000;
const BaseUrl = '/api/';

const ApiQRCodeBase = axios.create({
    baseURL: BaseUrl,
})

export default ApiQRCodeBase;

export const baseUrl = BaseUrl;